import React from "react";

export function TextStack({ primary, secondary, primaryClassName = "" }) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <span className={`font-semibold text-slate-900 ${primaryClassName}`}>
        {primary || "-"}
      </span>
      {secondary ? <span className="text-slate-500">{secondary}</span> : null}
    </div>
  );
}

export function MediaCell({ src, alt, title, subtitle, size = "md" }) {
  const imageSize = size === "lg" ? "h-16 w-24" : "h-14 w-14";

  return (
    <div className="flex min-w-0 items-center gap-4">
      {src ? (
        <img
          src={src}
          alt={alt || title || ""}
          className={`${imageSize} shrink-0 rounded-md object-cover`}
        />
      ) : null}
      <TextStack primary={title} secondary={subtitle} />
    </div>
  );
}

export function InitialsAvatar({ name, fallback = "?" }) {
  const initials = (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return (
    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-200 text-base font-semibold text-slate-600">
      {initials || fallback}
    </span>
  );
}
